import NotFound from '@common/NotFound'
import type { Permission, UserRole } from '@gql'
import useUser from '@hooks/useUser'
import type { MatchAccessType, UserAccess } from '@sections/auth/access'
import { hasUserAccess } from '@sections/auth/access'
import type React from 'react'

interface SectionRouteProps {
  permissions?: Permission[]
  roles?: UserRole[]
  matchAccess?: MatchAccessType
  children: React.ReactElement
}

export const SectionRoute: React.FC<SectionRouteProps> = ({
  permissions,
  roles,
  matchAccess = 'all',
  children,
}) => {
  const { user } = useUser()

  const access = {
    [matchAccess]: [
      ...(permissions?.map((permission) => ({ permission })) ?? []),
      ...(roles?.map((role) => ({ role })) ?? []),
    ],
  } as UserAccess

  const canAccess = (!permissions?.length && !roles?.length) || hasUserAccess(user, access)
  return canAccess ? children : <NotFound />
}

SectionRoute.displayName = 'Route'
export default SectionRoute
